import {Observable} from 'rxjs';
import {OrderedMap} from 'immutable';

import {combineEpics} from 'web-app/util/redux-observable';
import Area from 'web-app/react/entities/areas/model';
import Organization from 'web-app/react/entities/organizations/model';
import InstitutionPreview from 'web-app/react/entities/institutions-preview/model';
import * as InstitutionPreviewActions from 'web-app/react/entities/institutions-preview/actions';
import AreaActions from 'web-app/react/entities/areas/actions';

import * as Api from './api';
import * as Actions from './actions';

export const fetchOrganizationObservable = organizationId =>
    Api.getOrganization(organizationId).map(organization => {
        const institutions = organization.institutions.map(InstitutionPreview.fromAPI);
        const areasMap = OrderedMap(
            organization.institutionGroupings.map(Area.fromAPI).map(area => [area.areaId, area]),
        );

        return [
            Actions.fetchSuccess.action(Organization.fromAPI(organization)),
            AreaActions.fetchAllSuccess(areasMap, organizationId),
            InstitutionPreviewActions.fetchAllSuccess.action(institutions, organizationId),
        ];
    });

const fetchOrganization = action$ =>
    action$.ofType(Actions.fetch.type).mergeMap(({payload}) =>
        fetchOrganizationObservable(payload.organizationId)
            .flatMap(actions => actions)
            .catch(e => Observable.of(Actions.fetchFailed.action(e))),
    );

export default combineEpics(fetchOrganization);
